/**
 * @module doesClientConfigurationExistInCache
 */

import { CLIENT_CONFIGURATION_LOCAL_STORAGE_KEY } from '../constants';
import { getItem, localStorageExists } from 'owa-local-storage';

/**
 * @function
 * Checks whether the client configuration is available in the long term cache
 * @returns whether the client configuration is present in the cache
 */

const doesClientConfigurationExistInCache = (): boolean => {
    if (!localStorageExists(window)) {
        return false;
    }
    return !!getItem(window, CLIENT_CONFIGURATION_LOCAL_STORAGE_KEY);
};

export default doesClientConfigurationExistInCache;
